import { Link } from "react-router-dom";

const BaseNav = ({active}) => {
    const links = [
        {
            link_name:"Overview",
            link_path:"/dashboard/",
            active:false
        },
        {
            link_name:"Mine",
            link_path:"/dashboard/mine",
            active:false
        },
        {
            link_name:"Referrals",
            link_path:"/dashboard/referral",
            active:false
        },
        {
            link_name:"Share & Earn",
            link_path:"",
            active:false
        },
        {
            link_name:"Withdraw",
            link_path:"/dashboard/withdraw",
            active:false
        },
        {
            link_name:"Marketplace",
            link_path:"/dashboard/marketplace",
            active:false
        },
        {
            link_name:"Notifications",
            link_path:"/dashboard/notifications",
            active:false
        },
        {
            link_name:"Upgrade",
            link_path:"/dashboard/upgrade",
            active:false
        },
        {
            link_name:"Community",
            link_path:"/dashboard/comunity",
            active:false
        }
        
    ]
    const filtered_links = links.map(each=> each.link_name == active ? {...each,active:true} : each)
    return ( 
        <div className="base-nav">
                    <div className="container">
                        <div className="scroll-wrapper">
                            <nav>
                                {
                                    filtered_links.map(link=>(
                                        <Link to={`${link.link_path}`} className={`${active == link.link_name ? "active" : ""}`}>{link.link_name}</Link>
                                    ))
                                }
                                {/* <a href="#" className="active">Overview</a>
                                <Link to="/mine">Mine</Link>
                                <Link to="/referral" >Referals</Link>
                                <a href="#">Share & Earn</a>
                                <a href="/withdraw">Withdraw</a>
                                <a href="#">Marketplace</a>
                                <Link to="/notifications">Notifications</Link>
                                <a href="/upgrade">Upgrade</a> */}
                            </nav>
                        </div>

                    </div>
            </div>
     );
}
 
export default BaseNav;
